import React from 'react';
import { Space } from 'antd';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import CheckDetailButtonsWithModal from './CheckDetailButtonsWithModal';
import type { ColumnsType } from 'antd/es/table';
import type { ArrangementReservationForTable } from '../types';
import UpdateProcessButtonWithModal from './UpdateProcessButtonWithModal';
import CancelCarButton from './CancelCarButton';

dayjs.extend(advancedFormat);

const createdTimeSorter = (
  a: ArrangementReservationForTable,
  b: ArrangementReservationForTable
) => {
  if (
    Number(dayjs(a.createdTime).format('x')) -
      Number(dayjs(b.createdTime).format('x')) >
    0
  ) {
    return 1;
  } else if (
    Number(dayjs(a.createdTime).format('x')) -
      Number(dayjs(b.createdTime).format('x')) <
    0
  ) {
    return -1;
  } else {
    return 0;
  }
};

const reservationTimeSorter = (
  a: ArrangementReservationForTable,
  b: ArrangementReservationForTable
) => {
  if (
    Number(dayjs(a.reservationTime).format('x')) -
      Number(dayjs(b.reservationTime).format('x')) >
    0
  ) {
    return 1;
  } else if (
    Number(dayjs(a.reservationTime).format('x')) -
      Number(dayjs(b.reservationTime).format('x')) <
    0
  ) {
    return -1;
  } else {
    return 0;
  }
};

export const waitArrangeReservationColumns: ColumnsType<ArrangementReservationForTable> =
  [
    {
      title: '登記時間(年/月/日)',
      dataIndex: 'createdTime',
      sorter: {
        compare: createdTimeSorter,
      },
    },
    {
      title: '預約乘車時間(年/月/日)',
      dataIndex: 'reservationTime',
      sorter: {
        compare: reservationTimeSorter,
      },
    },
    { title: '戶號', dataIndex: 'householdNumber' },
    { title: '住戶', dataIndex: 'name' },
    {
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      render: (texts: string[], record) => {
        return (
          <Space>
            <CheckDetailButtonsWithModal reservationId={record.key} />
            <UpdateProcessButtonWithModal reservation={record} />
            <CancelCarButton reservation={record} />
          </Space>
        );
      },
    },
  ];

export const arrangedReservationColumns: ColumnsType<ArrangementReservationForTable> =
  [
    {
      title: '登記時間(年/月/日)',
      dataIndex: 'createdTime',
      sorter: {
        compare: createdTimeSorter,
      },
    },
    {
      title: '預約乘車時間(年/月/日)',
      dataIndex: 'reservationTime',
      sorter: {
        compare: reservationTimeSorter,
      },
    },
    { title: '戶號', dataIndex: 'householdNumber' },
    { title: '住戶', dataIndex: 'name' },
    { title: '車隊名稱', dataIndex: 'fleetName' },
    { title: '車牌號碼', dataIndex: 'carNumber' },
    {
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      render: (texts: string[], record) => {
        return (
          <Space>
            <CheckDetailButtonsWithModal reservationId={record.key} />
            <CancelCarButton reservation={record} />
          </Space>
        );
      },
    },
  ];

export const historyReservationColumns: ColumnsType<ArrangementReservationForTable> =
  [
    {
      title: '登記時間(年/月/日)',
      dataIndex: 'createdTime',
      sorter: {
        compare: createdTimeSorter,
      },
    },
    {
      title: '預約乘車時間(年/月/日)',
      dataIndex: 'reservationTime',
      sorter: {
        compare: reservationTimeSorter,
      },
    },
    { title: '戶號', dataIndex: 'householdNumber' },
    { title: '住戶', dataIndex: 'name' },
    { title: '狀態', dataIndex: 'status' },
    { title: '車隊名稱', dataIndex: 'fleetName' },
    {
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      render: (texts: string[], record) => {
        return (
          <Space>
            <CheckDetailButtonsWithModal reservationId={record.key} />
          </Space>
        );
      },
    },
  ];
